export default "https://cdn.cloudgame.qcloud.com/static/sg/prod/dist/img/dialog_cover_my.7281a948dbf55b05954e447b45ebd02c.png";